import React from 'react';
import { useReveal } from '../../hooks/useReveal';
import styles from './Reveal.module.css';

interface Props {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
  style?: React.CSSProperties;
}

const Reveal: React.FC<Props> = ({ children, delay = 0, className = '', as = 'div', style = {} }) => {
  const { ref, visible } = useReveal<HTMLDivElement>();
  const Tag = as as any;
  return (
    <Tag
      ref={ref}
      className={`${styles.reveal} ${visible ? styles.visible : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms`, ...style }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
